var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBulkOrderSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8492 34H4.88561C4.48719 34.0023 4.10198 33.8649 3.80436 33.6145C3.50673 33.364 3.31778 33.0182 3.27396 32.6438L2.00077 14.5792C1.99406 14.3774 2.03115 14.1764 2.10976 13.9887C2.18838 13.8009 2.30685 13.6304 2.45786 13.4876C2.60887 13.3448 2.78924 13.2328 2.98781 13.1585C3.18638 13.0841 3.39896 13.0491 3.61242 13.0554H32.3884C32.8158 13.0554 33.2257 13.216 33.528 13.5017C33.8302 13.7875 34 14.1751 34 14.5792L32.4609 32.659C32.4134 33.0307 32.2228 33.3728 31.9256 33.6202C31.6283 33.8675 31.2452 34.0027 30.8492 34V34Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93848 17.9999V9.61898C9.93848 7.5983 10.7875 5.66038 12.2987 4.23154C13.8099 2.80271 15.8595 2 17.9967 2C20.1339 2 22.1835 2.80271 23.6947 4.23154C25.206 5.66038 26.0549 7.5983 26.0549 9.61898V17.9999",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBulkOrderSelected);
export default __webpack_public_path__ + "static/media/ic_bulk_order_selected.542303b83a852cc53d959464290cf5fd.svg";
export { ForwardRef as ReactComponent };